import { Dropdown } from 'ccs-ui-components';
import { Col, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { SERVICE_TYPE } from '../../../../../constants';

interface IServiceTypeProps {
  serviceTypeValue: string | undefined;
  typeChangeHandler: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}
const ServiceType = ({
  typeChangeHandler,
  serviceTypeValue
}: IServiceTypeProps) => {
  const { t: translate } = useTranslation();
  return (
    <Col md={6}>
      <Form.Group controlId="serviceType">
        <Dropdown
          isMandatory
          labelText={String(translate('service_details_form_component.lbl_service_type'))}
          infoIconTxt={String(translate('service_details_form_component.service_type_info_bubble'))}
          label=""
          data={SERVICE_TYPE}
          value={serviceTypeValue}
          name="serviceType"
          onChange={typeChangeHandler}
          data-testid="service-type-dropdown"
          placeholder={
            String(translate('fsm_registry_form.lbl_placeholder_select'))
          }
          id="serviceType"
        />
      </Form.Group>
    </Col>
  );
};

export default ServiceType;
